import React from 'react';
import * as Styled from './AppContainer.styles';
import { CollectionsContainer } from '../CollectionsContainer/CollectionsContainer';

export const AppContainer = () => {
  return (
    <Styled.AppWrapper>
      <CollectionsContainer />
    </Styled.AppWrapper>
  );
};
